import React, { useEffect, useRef, useState } from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

const STEPS = [
  { n: '01', img: 'image66.png', de: 'Mine', en: 'Mine' },
  { n: '02', img: 'image64.png', de: 'Schleiferei', en: 'Cutting facility' },
  { n: '03', img: 'image63.png', de: 'Zertifizierung', en: 'Certification' },
  { n: '04', img: 'image59.png', de: 'Endkunde', en: 'End customer' },
];

const DE = {
  overline: 'STIG ROCK',
  title: 'Der STIG ROCK Weg',
  fazit: 'Durch die verkürzte Lieferkette entfallen die größten Kostenpositionen.',
  fazitBigPre: 'Dies ermöglicht einen Preisnachlass von bis zu',
  fazitBigValue: '80%',
};
const EN = {
  overline: 'STIG ROCK',
  title: 'The STIG ROCK Way',
  fazit: 'The shortened supply chain eliminates the biggest cost positions.',
  fazitBigPre: 'This enables a price discount of up to',
  fazitBigValue: '80%',
};

/* Folie nach "Der traditionelle Weg": Headline sofort, Klick 1 →
   Kette Mine → Schleiferei → Zertifizierung → Endkunde + Fazit. */
export default function SectionStigWeg() {
  const { t, lang } = useT();
  const m = t.stigRockWeg || (lang === 'de' ? DE : EN);
  const [revealed, setRevealed] = useState(false);
  const shellRef = useRef(null);

  useEffect(() => {
    const node = shellRef.current;
    if (!node) return undefined;
    const onFragment = () => setRevealed(true);
    node.addEventListener('fragment-advance', onFragment);
    return () => node.removeEventListener('fragment-advance', onFragment);
  }, []);

  return (
    <SectionShell id="stig-weg" centerContent>
      <div
        ref={shellRef}
        data-fragments-remaining={revealed ? 0 : 1}
        data-testid="stig-weg-shell"
        className="w-full"
      >
        <Reveal>
          <div className="overline mb-4">{m.overline}</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-white mb-10">
            {m.title}
          </h2>
        </Reveal>

        <div className={`sw-flow ${revealed ? 'sw-visible' : ''}`} data-testid="stig-weg-flow">
          <div className="sw-grid">
            {STEPS.map((s, i) => (
              <div key={s.n} className="sw-step" style={{ transitionDelay: `${i * 140}ms` }} data-testid={`stig-weg-step-${s.n}`}>
                <div className="trad-circle sw-circle">
                  <img
                    src={`/source-pptx/${s.img}`}
                    alt={(m.steps && m.steps[i]) || (lang === 'de' ? s.de : s.en)}
                    loading="lazy"
                    draggable={false}
                    className="block w-full h-full object-cover select-none"
                  />
                  <span className="trad-circle-ring" aria-hidden />
                </div>
                <div className="sw-step-label font-display">{(m.steps && m.steps[i]) || (lang === 'de' ? s.de : s.en)}</div>
                {i < STEPS.length - 1 && <span className="sw-arrow" aria-hidden>→</span>}
              </div>
            ))}
          </div>

          <p className="sw-fazit font-ui" data-testid="stig-weg-fazit">{m.fazit}</p>
          <p className="sw-fazit-big font-display" data-testid="stig-weg-fazit-big">
            {m.fazitBigPre} <span className="sw-fazit-value">{m.fazitBigValue}</span>
          </p>
        </div>
      </div>
    </SectionShell>
  );
}
